import { useContext } from 'react';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import useService from '../utils/useService';

export const makeActionHandler = (action: any, params: any) => {
	if (!params) {
		return () => {};
	}

	const {
		history,
		rowData = EMPTY_OBJECT,
		setShowLoader = () => {},
		setForceUpdateRows = () => {},
		setConfirmationDialog
	} = params;

	const { showAlert } = useContext(AppContext);
	const { requestPromoteOnProd } = useService();

	switch (action.id) {
		case 'edit':
			return () => {
				if (typeof setConfirmationDialog !== 'function') {
					return;
				}
				if (rowData.isPreProd) {
					setConfirmationDialog({
						show: true,
						header: 'Action Not Allowed',
						message: 'Please consult development team to cleanup pre-prod configuration',
						handleAlertConfirmation: () => {
							history.push('/gameAdmin/zkDashBoardUpdate/list');
						},
						confirmButtonText: 'OK',
						showConfirmButton: true,
						showCancelButton: false,
						showOkButton: true,
						cancelButtonText: '',
						hideCancel: true
					});
					return;
				}

				setConfirmationDialog({
					show: true,
					header: 'Please Confirm',
					message: `Are you sure you want to edit all ${rowData.deviceType} configurations on pre prod?`,
					handleAlertConfirmation: () => {
						history.push({
							pathname: '/gameAdmin/zkDashBoardUpdate/edit',
							state: {
								deviceType: rowData.deviceType,
								rowData
							}
						});
					}
				});
			};
		case 'promoteOnProd': {
			const toggleIsDisabled = async () => {
				try {
					if (typeof setShowLoader !== 'function') {
						return;
					}
					if (!rowData.isPreProd) {
						showAlert('Config does not exist on pre prod', { type: 'error' });
						return;
					}
					setShowLoader(true);
					const result = await requestPromoteOnProd();
					if (!result.data.success) {
						showAlert(`Failed to promote config: ${result.data.message || 'Unknown error'}`, { type: 'error' });
						return;
					}
					showAlert('Config promoted on prod successfully');
					setForceUpdateRows(true);
				} catch (err: any) {
					showAlert(`Error: ${err?.response?.data?.error || 'Unknown error occurred'}`, { type: 'error' });
				} finally {
					setShowLoader(false);
				}
			};

			return () => {
				if (typeof setConfirmationDialog !== 'function') {
					return;
				}

				if (!rowData.isPreProd) {
					setConfirmationDialog({
						show: true,
						header: 'Action Not Allowed',
						message: 'There is no config present on pre prod',
						showConfirmButton: false,
						showCancelButton: false,
						showOkButton: true,
						confirmButtonText: 'OK',
						hideCancel: true
					});
					return;
				}

				setConfirmationDialog({
					show: true,
					header: 'Please Confirm',
					message: 'Are you sure you want to promote this config on production?',
					handleAlertConfirmation: toggleIsDisabled
				});
			};
		}
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
